import React from 'react';

const SocialLogin = () => {
  const handleSocialLogin = (provider) => {
    alert(`Inicio de sesión con ${provider} próximamente disponible`);
  };

  return (
    <div className="space-y-3">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
      </div>
    </div>
  );
};

export default SocialLogin;
